module.exports = __webpack_public_path__ + "img/out-img1.4bc02c8c.png";